var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { tracked } from "@glimmer/tracking";
import { InsIdentityResultCode, InsStatus } from "cnam/types/types";
import { CnamApiCpsNoBillingNumber, CnamApiInsConflictWithSsnError, CnamApiInsIdentityCorruptedError, CnamApiInsMultipleIdentityFoundError, CnamApiInsNoIdentityFoundError, CnamApiInsNoSexError, CnamApiInsPatientInvalid } from "cnam/utils/cnam-api-errors";
import InsRetrieveAccessFormSetPracticeLocationWithBillingNumberComponent from "cnam/components/ins-retrieve-access-form/set-practice-location-with-billing-number";
import searchBirthPlace from "core/utils/search-birthplace";
import CnamContext, { State } from "./abstract/cnam-context";
let InsRetrievalContext = (_class = class InsRetrievalContext extends CnamContext {
  constructor(cnamAdapterName, patient, authenticationContext, insiAdapter, dmpAdapter, store, requestManager, operationType, onSuccess) {
    super(store, requestManager, cnamAdapterName, patient, operationType);
    _initializerDefineProperty(this, "checkedBillingNumber", _descriptor, this);
    _initializerDefineProperty(this, "validatedPatient", _descriptor2, this);
    _initializerDefineProperty(this, "practiceLocation", _descriptor3, this);
    _initializerDefineProperty(this, "insProcessNeeded", _descriptor4, this);
    _initializerDefineProperty(this, "identityResult", _descriptor5, this);
    this.authenticationContext = authenticationContext;
    this.insiAdapter = insiAdapter;
    this.dmpAdapter = dmpAdapter;
    this.onSuccess = onSuccess;
    this.authenticationContext.forcedIdentifier = this.authenticationContext.medic.forceIdentifierForInsRetrieval;
    this.states = [...this.states, new State("validate-patient", () => {
      return Promise.resolve(!this.validatedPatient && this.patient.insStatus != InsStatus.Qualified && this.insProcessNeeded);
    }, async () => {
      const missingMandatoryFields = [];
      if (!this.patient.birthday) {
        missingMandatoryFields.push("date de naissance");
      }
      if (!this.patient.gender) {
        missingMandatoryFields.push("sexe");
      }
      if (!this.patient.birthName && !this.patient.lastName) {
        missingMandatoryFields.push("nom de naissance");
      }
      if (!this.patient.birthFirstName && !this.patient.firstName) {
        missingMandatoryFields.push("prénom(s) de naissance");
      }
      if (missingMandatoryFields.length > 0) {
        throw new CnamApiInsPatientInvalid(`Il manque les informations suivantes dans la fiche patient : ${missingMandatoryFields.join(", ")}.`);
      } else {
        this.validatedPatient = true;
      }
    }), new State("check-valid-billing-number", () => {
      return Promise.resolve(!(this.authenticationContext.billingNumber || this.checkedBillingNumber) && this.patient.insStatus != InsStatus.Qualified && this.insProcessNeeded);
    }, async () => {
      if (this.authenticationContext.practiceLocationsWithValidBillingNumber.length == 0) {
        throw new CnamApiCpsNoBillingNumber();
      }
      this.checkedBillingNumber = true;
    }), new State("select-another-practice-location-with-billing-number", () => {
      return Promise.resolve(!this.authenticationContext.billingNumber && this.checkedBillingNumber && this.authenticationContext.practiceLocationsWithValidBillingNumber.length > 0 && this.patient.insStatus != InsStatus.Qualified && this.insProcessNeeded);
    }, async () => {
      this.authenticationContext.practiceLocation = this.practiceLocation;
      await this.authenticationContext.updatePracticeLocationNameAndIndice();
    }, InsRetrieveAccessFormSetPracticeLocationWithBillingNumberComponent), new State("retrieve-ins", () => {
      return Promise.resolve(this.patient.insStatus != InsStatus.Qualified && this.insProcessNeeded);
    }, async () => {
      try {
        const identity = await this.insiAdapter.retrieveInsIdentity(this.patient);
        this._checkIdentityResponse(identity, patient.socialSecurityNumber);
        this.identityResult = identity;
        this.insProcessNeeded = false;
      } catch (error) {
        const identity = error.identity;
        if (identity) {
          await this._saveInsRetrieve(patient, identity, false);
        }
        throw error;
      }
    })];
  }
  _checkIdentityResponse(identity, currentSsn) {
    if (identity.result == InsIdentityResultCode.InsIdentityResult_NoIdentityFound && !identity.identity) {
      throw new CnamApiInsNoIdentityFoundError("", undefined, identity);
    } else if (identity.result == InsIdentityResultCode.InsIdentityResult_MultipleIdentitiesFound && !identity.identity) {
      throw new CnamApiInsMultipleIdentityFoundError("", undefined, identity);
    } else if (!(identity.birthGiven && identity.birthName && identity.birthday && identity.sex)) {
      throw new CnamApiInsIdentityCorruptedError("", undefined, identity);
    } else if (currentSsn && this._removeSuffix(currentSsn) !== this._computeSsn(identity)) {
      throw new CnamApiInsConflictWithSsnError("", undefined, identity);
    } else if (!identity.sex) {
      throw new CnamApiInsNoSexError("", undefined, identity);
    }
  }
  _computeSsn(identity) {
    if (!identity || !identity.identity) return "";
    return `${identity.identity.value}${identity.identity.key}`;
  }
  _removeSuffix(nir) {
    return nir.replace(/D|T|A/, "");
  }
  async _savePatientIdentity(identity, patient) {
    if (identity.result == InsIdentityResultCode.InsIdentityResult_SingleIdentityFound && identity.identity) {
      patient.socialSecurityNumber = `${identity.identity?.value}${identity.identity?.key}`;
      patient.insOid = identity.identity.oid;
      patient.insKey = identity.identity.key;
      patient.firstBirthFirstName ??= identity.birthGiven ? identity.birthGiven?.split(" ")[0] : "";
      patient.birthFirstName = identity.birthGiven;
      patient.birthName = identity.birthName;
      patient.birthday = identity.birthday;
      patient.birthMunicipalityCode = identity.birthPlace;
      if (identity.birthPlace) {
        patient.birthPlace = await searchBirthPlace(identity.birthPlace);
      }
      patient.gender = identity.sex;
      patient.insValue = identity.identity.value;
      await patient.save();
    }
  }
  async _saveInsRetrieve(patient, identity, succeed) {
    await this.store.createRecord("ins-retrieved-journal-event", {
      patient,
      occurredAt: new Date(),
      identity,
      succeed,
      cnamProcessStartedJournalEvent: this.cnamProcessStartedJournalEvent
    }).save();

    // insStatus of the patient is computed server-side when an "ins-retrieved-journal-event" is pushed.
    // Let's retrieve it.
    await patient.reload();
  }
  reset() {
    super.reset();
    this.validatedPatient = false;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "checkedBillingNumber", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "validatedPatient", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "practiceLocation", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "insProcessNeeded", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return true;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "identityResult", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { InsRetrievalContext as default };